import * as store from '@attain-apps/fe/web/main/lib/store'
import * as rxjs from 'rxjs'

import type { Collection } from '../collection'

/**
 * Effect that groups conversations by agentId using the groupPlugin. Creates a
 * group for each unique agentId found in the current list of conversations.
 */
export const onConversationAdded = store.effects.create(
  (feature: Collection['feature'], collection: Collection) =>
    collection.feature.selectors.context.asObservable.pipe(
      rxjs.switchMap(context =>
        (collection.api.onChange?.(context) ?? rxjs.EMPTY).pipe(
          rxjs.switchMap(conversation =>
            collection.plugins.currentListPlugin.feature.selectors.entities.asObservable.pipe(
              // The subscription event identifies which conversation should be
              // selected, but current-list reconciliation runs separately and
              // can rewrite the current entity lookup as the list changes. Wait
              // for this exact conversation to reach the list, then select it
              // once so later list refreshes cannot re-select a stale event.
              rxjs.filter(conversations =>
                conversations.some(({ id }) => id === conversation.id),
              ),
              rxjs.take(1),
              rxjs.map(() =>
                collection.plugins.currentEntityPlugin.storage.actions.putInIdLookup.request
                  .from('onConversationAdded (effect)')
                  .create({
                    value: conversation.id,
                  }),
              ),
            ),
          ),
        ),
      ),
    ),
)
